module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/id_card_entrance_new.ef322975.png";